var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"frame",staticClass:"pdf-container",attrs:{"src":"/plugin/pdfjs-hanhua/web/viewer.html?file=","data-src":_vm.innerSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }